module.exports = __webpack_public_path__ + "img/holandes.e55281d7.svg";